// Lookups over the generated skill registry, with language fallback to English
// (a Malay string in the registry is a draft behind native review; a missing one
// shows the English).

import { SKILLS, type LocalizedText, type SkillDef } from "./skillRegistry.generated";

/** Skill-garden beds (catalogue skill_domain), in the order the app shows them. */
export const DOMAIN_ORDER = [
  "language",
  "literacy",
  "numeracy",
  "executive_function",
  "social_emotional",
  "daily_life",
  "motor",
  "perception",
  "creativity",
  "attention",
] as const;

const BY_ID = new Map<string, SkillDef>(SKILLS.map((s) => [s.id, s]));

export function skillById(id: string): SkillDef | undefined {
  return BY_ID.get(id);
}

export function localized(text: LocalizedText | undefined, locale: string): string {
  if (!text) return "";
  const v = text[locale];
  return typeof v === "string" && v.trim().length > 0 ? v : text.en;
}

export function domainRank(domain: string): number {
  const i = (DOMAIN_ORDER as readonly string[]).indexOf(domain);
  return i === -1 ? DOMAIN_ORDER.length : i;
}

/** Registry order index of a skill (stable sort within a bed). */
export function skillRank(id: string): number {
  const i = SKILLS.findIndex((s) => s.id === id);
  return i === -1 ? SKILLS.length : i;
}
